import i18n from 'i18next';
import enTranslation from './locales/en/translation.json';
import enSearch from './locales/en/search.json';
import enAd from './locales/en/ad.json';
import enAirdo from './locales/en/airdo.json';
import enOtherAirlines from './locales/en/other_airlines.json';
import enTaxi from './locales/en/taxi.json';
import jaTranslation from './locales/ja/translation.json';
import jaSearch from './locales/ja/search.json';
import jaAd from './locales/ja/ad.json';
import jaAirdo from './locales/ja/airdo.json';
import jaOtherAirlines from './locales/ja/other_airlines.json';
import jaTaxi from './locales/ja/taxi.json';
import {initReactI18next} from 'react-i18next';

const resources = {
  en: {
    translation: enTranslation,
    search: enSearch,
    ad: enAd,
    airdo: enAirdo,
    otherAirlines: enOtherAirlines,
    taxi: enTaxi
  },
  ja: {
    translation: jaTranslation,
    search: jaSearch,
    ad: jaAd,
    airdo: jaAirdo,
    otherAirlines: jaOtherAirlines,
    taxi: jaTaxi
  },
};

i18n
  .use(initReactI18next)
  .init({
    lng: 'ja',
    ns: ['translation', 'search', 'ad', 'taxi', 'airdo' ],
    defaultNS: 'translation',
    fallbackLng: 'ja',
    debug: true,

    interpolation: {
      escapeValue: false,
    },

    react: {
      wait: true,
    },
    resources: resources,
  });

export default i18n;
